/**
 * A new password: the current one first (an account made through Google or GitHub, which has
 * none, gives its first one). The other devices are signed out afterwards.
 */
import { Show, createSignal, type JSX } from "solid-js";
import { toast } from "../shared/toast";
import { usePages } from "./context";

/** The password section. */
export function AccountPassword(): JSX.Element {
  const { accounts, server } = usePages();
  const [old, setOld] = createSignal("");
  const [fresh, setFresh] = createSignal("");
  const has = () => accounts.me(server)?.has_password !== false;
  const change = async () => {
    const done = await accounts.call(server, (a) => a.changePassword(old(), fresh()).then(() => true));
    if (!done) return;
    setOld("");
    setFresh("");
    toast("Password changed. Your other devices are signed out.");
    await accounts.refresh(server);
  };
  return (
    <section class="team-section" id="account-password">
      <h3>{has() ? "Password" : "Add a password"}</h3>
      <form
        class="pages-form"
        onSubmit={(e) => {
          e.preventDefault();
          void change();
        }}
      >
        <Show when={has()}>
          <label>
            Current password
            <input class="field" id="account-password-old" type="password" autocomplete="current-password" required value={old()} onInput={(e) => setOld(e.currentTarget.value)} />
          </label>
        </Show>
        <label>
          New password <span class="muted small">(at least 8 characters, not a common one)</span>
          <input class="field" id="account-password-new" type="password" autocomplete="new-password" required value={fresh()} onInput={(e) => setFresh(e.currentTarget.value)} />
        </label>
        <button type="submit" class="btn" id="account-password-submit">
          {has() ? "Change password" : "Add password"}
        </button>
      </form>
    </section>
  );
}
